import * as React from 'react';
import './StressBarometerAdmin.css';
import { inject, observer } from 'mobx-react';
import { AppStore } from '../../../stores';
import StressBarometerAdminPanel from './stressBarometerAdminPanel/StressBarometerAdminPanel';
import { IStressBarometer } from '../../../interfaces/IStressBarometer';
import StressBarometerService from '../../../services/StressBarometerService';
import StressBarometerCard from './stressBarometerCard/StressBarometerCard';
import StressBarometerUserPanel from './stressBarometerUserPanel/StressBarometerUserPanel';

export interface IProps {
  open: boolean;
  close: () => void;
  appStore?: AppStore;
}

export interface IState {
  showButtons: boolean;
  hasAccess?: boolean;
  result?: number[];
  loading?: boolean;
  stressBarometers?: IStressBarometer[];
}

@inject('appStore')
@observer
export default class StressBarometerAdmin extends React.Component<IProps, IState> {

  constructor(props) {
    super(props);
    this.state = {
      showButtons: false,
      result: [1, 5, 7, 4, 3, 6, 2, 9]
    }
  }

  public componentWillReceiveProps(props: IProps): void {
    if (this.props.open !== props.open && props.open) {
      setTimeout(() => {
        this.setState({ showButtons: true });
      }, 500);
      this.getStressBarometersForAdmin();
    }
  }

  private getStressBarometersForAdmin() {
    this.setState({ loading: true });
    StressBarometerService.getStressBarometersForAdmin(this.props.appStore!.user?.id || "").then((stressBarometers: IStressBarometer[]) => {
      this.setState({ stressBarometers, loading: false });
    });
    // Implementation for fetching stress barometers for admin
  }

  render() {
    const stressBarometersToRender = [];
    if (this.state.stressBarometers?.length > 0) {
      this.state.stressBarometers.forEach((stressBarometer: IStressBarometer) => {
        stressBarometersToRender.push(
          <StressBarometerCard
            key={stressBarometer.objectId}
            stressBarometer={stressBarometer}
            adminView={true}
          />
        );
      });
    }
    return (
      <div
        className='stressBarometer'
        style={{
          top: this.props.appStore!.showStressBarometer ? (this.props.appStore!.isMobile ? 0 : 50) : screen.height,
          height: this.props.appStore!.podcastToPlay ? (this.props.appStore!.isMobile ? "calc(100% - 101px)" : "calc(100% - 151px)") : (this.props.appStore!.isMobile ? "100%" : "calc(100% - 50px)")
        }}
      >
        <>
          <div className="stressBarometerCover">
            <div
              className="stressBarometerCoverImage"
              style={{
                backgroundImage: `url(https://dojo.mindjuice.com/images/stressbarometer-header.png)`
              }}
            />
          </div>
          <div className='stressBarometerContentWrapper'>
            {this.state.showButtons &&
              <div
                className='closeButton'
                onClick={() => {
                  this.setState({ showButtons: false });
                  this.props.appStore!.showStressBarometer = undefined;
                  //history.back();
                }}
              />
            }
            {this.state.showButtons &&
              <div
                className='saveStressBarometerButton'
                onClick={() => {
                  this.props.appStore!.stressBarometerToEdit = {
                    allowUserToEditAreas: true,
                    adminId: this.props.appStore!.user?.id,
                    title: "",
                    areas: [
                      { title: window.loc.strings.stressBarometerAreaPhysicalHealth },
                      { title: window.loc.strings.stressBarometerAreaMentalClarity },
                      { title: window.loc.strings.stressBarometerAreaRelationships },
                      { title: window.loc.strings.stressBarometerAreaWorkBalance },
                      { title: window.loc.strings.stressBarometerAreaFinancial },
                      { title: window.loc.strings.stressBarometerAreaPersonalGrowth },
                      { title: window.loc.strings.stressBarometerAreaRecreation },
                      { title: window.loc.strings.stressBarometerAreaSpirituality },
                    ],
                  }
                }}
              >
                {window.loc.strings.createNewStressBarometer}
              </div>
            }
            <div className='teamTestContent'>
              <div className="teamTestGroups">
                {this.state.loading ? (
                  <div>{window.loc.strings.loading}</div>
                ) : (
                  (stressBarometersToRender?.length === 0 ? (
                    <div className="noGroups">
                      {window.loc.strings.noGroups}
                    </div>
                  ) : (
                    <div className='groups'>
                      {stressBarometersToRender}
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        </>
        <StressBarometerAdminPanel
          appStore={this.props.appStore}
          id={this.props.appStore!.stressBarometerToEdit?.objectId}
          reload={() => {
            this.getStressBarometersForAdmin();
          }}
        />
      </div>
    );
  }
}